module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0002.f55ac1d8.png";